import { T }         from 'defa-object';
import ControlModule from 'scripts/poppet/control-module';
import template      from './controlGeneralAlarmInputView.jst.html';
import { Vue }       from 'vue/defavue';

const generalAlarmOptions     = [
	{ value: 'ON', 	title: T.tc( 'GeneralAlarmInput', 'On' ), 	titleContext: 'GeneralAlarmInput' },
	{ value: 'OFF', title: T.tc('GeneralAlarmInput', 'Off' ),	titleContext: 'GeneralAlarmInput' }
];

export const ControlGeneralAlarmInputView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	className: function () {
		return this._getClassName( 'control-general-alarm-input' );
	},
	
	onDomRefresh() {
		let self   = this;
		
		let generalAlarmInputSlider = new Vue ({
			el: '#generalAlarm-slider',
			
			bb() {
				return {
					model: self.model,
				};
			},
			
			data() {
				return {
					generalAlarmValue: 'ON',
					generalAlarmOptions,
				}
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= {
						intruderAlarm: 'ON' === newValue,
					};
					self.save( data )
				},
			},
			
			watch: {
				'model.alarmMask': function (newAttribute){
					this.generalAlarmValue = newAttribute.intruderAlarm  ? 'ON' : 'OFF';
				}
			},
			
			created() {
				this.generalAlarmValue = this.model.alarmMask && this.model.alarmMask.intruderAlarm ? 'ON' : 'OFF';
			}
		});
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	save: function(attributes) {
		this.model.set('isValidData', false);
		try {
			this.model.save(attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			});
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}
});

export default  ControlGeneralAlarmInputView;
